export function camelCaseToCapitalized(str?: string): string | undefined {
  if (!str) return;
  // Replace capital letters with space + capital letter
  const withSpaces = str.replace(/([A-Z])/g, ' $1');
  
  // Capitalize first letter and trim any leading space
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1).trim();
}